var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.468,3.541h-3.761c-1.655,0-3.183.883-4.011,2.316l-2.292,3.971c-.827,1.433-.827,3.198,0,4.631l2.292,3.971c.827,1.433,2.356,2.316,4.011,2.316h4.585c1.655,0,3.183-.883,4.011-2.316l2.292-3.971c.827-1.433.827-3.198,0-4.631l-.208-.361"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.479,9.095c-1.36-.521-2.957-.239-4.053.857-1.486,1.486-1.486,3.896,0,5.383s3.896,1.486,5.383,0c1.129-1.129,1.395-2.789.81-4.174l3.178-3.178.108-1.233,1.257-.133.168-1.42,1.801-.549-1.309-2.897-7.344,7.344Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.854,
    cy: 12.907,
    r: 1.268
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminKey);
export default __webpack_public_path__ + "static/media/admin-key.b8cc2ec794126af73a54b390931ab428.svg";
export { ForwardRef as ReactComponent };